module.exports = __webpack_public_path__ + "img/icon_sm_ckrb.5222bbff.png";